<template>
	<div style="height: calc(100vh - 135px);overflow: auto;padding-right:3px">
		<div>
			<div class="page_header">
				<span class="page_title" style="flex: 1;float:left">
					{{ $t('drivermanagement.drivermanagement') }}</span>
				<el-form :inline="true" class="demo-form-inline" size="small" style="float: right;">
					<el-form-item :label="$t('drivermanagement.drivername')">
						<el-input v-model="driverName" :placeholder="$t('drivermanagement.inputdriver')"
							clearable></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit">{{ $t('public.query') }}</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="success" @click="add">{{ $t('public.add') }}</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" plain @click="download">{{ $t('public.export') }}</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div style="background: #C5D0E2;height: 1px;margin:30px 0px">
			</div>
		</div>

		<div>
			<el-table border ref="multipleTable" :data="tableData" tooltip-effect="dark" v-loading="loading"
				style="width: 100%">

				<el-table-column :label="$t('public.index')" type="index" width="50" align="center">
				</el-table-column>
				<el-table-column prop="Driver" :label="$t('drivermanagement.driver')" width="110" align="center">
				</el-table-column>
				<el-table-column prop="DriverICNo" :label="$t('drivermanagement.driverICNo')" width="140"
					align="center">
				</el-table-column>
				<el-table-column prop="DriverlicenseNo" :label="$t('drivermanagement.driverlicenseNo')" width="140"
					align="center">
				</el-table-column>
				<el-table-column prop="ContactNo" :label="$t('drivermanagement.contactNo')" align="center">
				</el-table-column>
				<el-table-column prop="LicenseValidityPeriod" :label="$t('drivermanagement.licenseValidityPeriod')"
					width="140" align="center">
				</el-table-column>

				<el-table-column prop="QualificationCertificate" width="100"
					:label="$t('drivermanagement.qualificationCertificate')" align="center">
				</el-table-column>
				<el-table-column prop="QCValidityperiod" :label="$t('drivermanagement.qCValidityperiod')" width="140"
					align="center">
				</el-table-column>
				<el-table-column :label="$t('public.Operation')" align="center" width="180" fixed="right">
					<template slot-scope="scope">
						<el-button size="mini" type='success' @click="modify(scope.$index, scope.row)">{{
							$t("public.edit")
						}}</el-button>
						<el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">{{
							$t("public.del")
						}}</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div style="text-align: right;margin-top:8px;margin-right: 40px" class="pagination" v-show="total > 0">
				<!--  -->
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
			<el-dialog class="adddriverlist" :title="drivertitle" :visible.sync="dialogFormVisible"
				:width="LanguageId == 1 ? '700px' : '930px'" :close-on-click-modal="false">
				<!-- <div style="background-color:#E8F0FF;height: 1px;"></div> -->
				<div class="registrationInfo">
					{{ $t("drivermanagement.basicInfo") }}
				</div>
				<el-row style="background: #FFFFFF;padding: 10px 10px;">
					<el-col :span="12">
						<div class="grid-content bg-purple">
							<el-form label-position="right" label-width="270px" :model="driverInfo" size="mini"
								:label-width="LanguageId == 1 ? '110px' : '270px'" :rules="rules" ref="driverInfo">
								<el-form-item :label="$t('drivermanagement.driver') + '：'" style="margin-top: 10px;"
									prop="Driver">
									<el-input v-model="driverInfo.Driver"
										:placeholder="$t('drivermanagement.inputdriver')" clearable></el-input>
								</el-form-item>
								<el-form-item :label="$t('organstructure.branch') + '：'" style="margin-top: 15px;"
									prop="GroupID">
									<el-select size="small" filterable v-model="driverInfo.GroupID"
										:placeholder="$t('public.select')">
										<el-option v-for="item in vehicles" :key="item.nodeValue" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>

								<el-form-item :label="$t('drivermanagement.employeeCardID') + '：'"
									style="margin-top: 15px;">
									<el-input v-model="driverInfo.EmployeeCardID"
										:placeholder="$t('drivermanagement.inputId')" clearable></el-input>
								</el-form-item>

								<el-form-item :label="$t('drivermanagement.gender') + '：'" style="margin-top: 15px;">
									<el-select size="small" filterable v-model="driverInfo.Sex"
										:placeholder="$t('public.select')">
										<el-option v-for="item in sextype" :label="item.label" :value="item.value"
											:key="item.value"></el-option>
									</el-select>
								</el-form-item>

								<el-form-item :label="$t('vehicle.Mobile') + '：'" prop="ContactNo"
									style="margin-top: 15px;">
									<el-input v-model="driverInfo.ContactNo"
										:placeholder="$t('operatormgr.please_opt_mobile')" maxlength='11'
										clearable></el-input>
								</el-form-item>
							</el-form>
						</div>
					</el-col>
					<el-col :span="12">
						<div class="grid-content bg-purple-light">
							<el-form label-position="right" :model="driverInfo" size="mini"
								:label-width="LanguageId == 1 ? '110px' : '270px'">
								<el-form-item :label="$t('drivermanagement.employeeno') + '：'"
									style="margin-top: 10px;">
									<el-input v-model="driverInfo.EmployeeCardNo"
										:placeholder="$t('drivermanagement.inputemployeeCarNo')" clearable></el-input>
								</el-form-item>

								<el-form-item :label="$t('drivermanagement.driverNo') + '：'" style="margin-top: 15px;">
									<el-input v-model="driverInfo.DriverWorkNo"
										:placeholder="$t('drivermanagement.inputdriverNo')" clearable></el-input>
								</el-form-item>

								<el-form-item :label="$t('state.title') + '：'" style="margin-top: 15px;">
									<el-select size="small" filterable v-model="newstatus"
										:placeholder="$t('public.select')">

										<el-option v-for="item in driverStatus" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>


								<el-form-item :label="$t('drivermanagement.icNo') + '：'" style="margin-top: 15px;">
									<el-input v-model="driverInfo.DriverICNo"
										:placeholder="$t('drivermanagement.inputicNo')" clearable
										oninput="if(value.length>11)value=value.slice(0,11)"
										onkeyup="this.value = this.value.replace(/[^\d]/g,'');"></el-input>
								</el-form-item>

							</el-form>
						</div>
					</el-col>
					<el-form :inline="true" :model="driverInfo" class="demo-form-inline" label-position="right"
						:label-width="LanguageId == 1 ? '110px' : '270px'" style="margin-top: 10px;">
						<el-form-item :label="$t('operatormgr.opt_addr') + '：'" style="margin-top: 15px;">
							<el-input type="textarea" v-model="driverInfo.HomeAddress" maxlength="100" show-word-limit
								:placeholder="$t('operatormgr.please_opt_addr')" clearable></el-input>
						</el-form-item>

						<el-form-item :label="$t('drivermanagement.driverProfile') + '：'">
							<el-input type="textarea" v-model="driverInfo.DriverProfile" maxlength="400" show-word-limit
								:placeholder="$t('drivermanagement.inputdriverProfile')" clearable></el-input>
						</el-form-item>
					</el-form>

				</el-row>

				<div class="registrationInfo">
					{{ $t('drivermanagement.driverInfo') }}
				</div>
				<el-row style="background: #FFFFFF;padding: 10px 10px;">
					<el-col :span="12">
						<el-form label-position="right" :model="driverInfo" size="mini"
							:label-width="LanguageId == 1 ? '130px' : '270px'">
							<el-form-item :label="$t('drivermanagement.licenseissunit') + '：'"
								style="margin-top: 10px;">
								<el-input v-model="driverInfo.LicenseIssuingUnit"
									:placeholder="$t('drivermanagement.licenseissunit')" clearable></el-input>
							</el-form-item>
							<el-form-item :label="$t('drivermanagement.authorizeddriver') + '：'"
								style="margin-top: 10px;">
								<el-select size="small" filterable v-model="quasiDrivingType"
									:placeholder="$t('public.select')">
									<el-option v-for="item in vehicletype" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item :label="$t('drivermanagement.qualification') + '：'" style="margin-top: 10px;">
								<el-input v-model="driverInfo.QualificationCertificate"
									:placeholder="$t('drivermanagement.inputqualification')" clearable></el-input>
							</el-form-item>
						</el-form>

					</el-col>
					<el-col :span="12">
						<el-form label-position="right" :model="driverInfo" size="mini"
							:label-width="LanguageId == 1 ? '130px' : '270px'">
							<el-form-item :label="$t('drivermanagement.licenseValidityPeriod') + '：'"
								style="margin-top: 10px;">
								<el-date-picker type="date"
									:placeholder="$t('drivermanagement.inputlicenseValidityPeriod')"
									value-format="yyyy-MM-dd" v-model="driverInfo.LicenseValidityPeriod"
									style="width: 100%;"></el-date-picker>
							</el-form-item>
							<el-form-item :label="$t('drivermanagement.driverlicenseNo') + '：'"
								style="margin-top: 10px;">
								<el-input v-model="driverInfo.DriverlicenseNo"
									:placeholder="$t('drivermanagement.inputdriverlicenseNo')" clearable></el-input>
							</el-form-item>
							<el-form-item :label="$t('drivermanagement.dateofcertificate') + '：'"
								style="margin-top: 10px;">
								<el-date-picker type="date" :placeholder="$t('public.select')" value-format="yyyy-MM-dd"
									v-model="driverInfo.QCValidityperiod" style="width: 100%;"></el-date-picker>
							</el-form-item>
						</el-form>
					</el-col>
				</el-row>
				<div slot="footer" class="dialog-footer" style="text-align: right;">
					<el-button size="small" @click="dialogFormVisible = false">{{ $t('public.cancel') }}</el-button>
					<el-button size="small" type="primary"
						@click="determine('driverInfo')">{{ $t('public.confirm') }}</el-button>
				</div>

			</el-dialog>
		</div>
	</div>
</template>
<script>
	import language from '@/utils/getLanguageId';

	import {
		mapState
	} from 'vuex'
	import rules from '@/utils/rules'
	export default {
		name: "driverManagement",
		data() {
			return {
				loading: false,
				total: 0,
				LanguageId: 1,
				quasiDrivingType: 0,
				drivertitle: this.$t('drivermanagement.adddriver'),
				dialogFormVisible: false,
				driverName: "",
				tableData: [],
				sextype: [{
						value: 0,
						label: this.$t('drivermanagement.female')
					},
					{
						value: 1,
						label: this.$t('drivermanagement.male')
					},
				],
				driverStatus: [{
						value: 0,
						label: this.$t('drivermanagement.onthejob')
					},
					{
						value: 1,
						label: this.$t('drivermanagement.quit')
					}, {
						value: 2,
						label: this.$t('drivermanagement.retire')
					}
				],
				vehicletype: [{
					value: 0,
					label: this.$t('drivermanagement.largebus')
				}, {
					value: 1,
					label: this.$t('drivermanagement.citybus')
				}, {
					value: 2,
					label: this.$t('drivermanagement.mediumbus')
				}, ],
				driverInfo: {},
				currentPage: 1,
				pageSize: 10,
				driverID: 0,
				vehicles: [],
				newstatus: "",
				rules: {
					Driver: [{
						required: true,
						message: this.$t('vehicleInfo.inputdrivername'),
						trigger: 'blur'
					}],
					GroupID: [{
						required: true,
						message: this.$t('drivermanagement.selectbranch'),
						trigger: 'change'
					}],
					ContactNo: [{
						pattern: /^1[3456789]\d{9}$/,
						message: this.$t('drivermanagement.inputphone'),
						trigger: "blur"
					}]
				}
			}
		},
		mounted() {
			//监听屏幕宽度
			var that = this;
			that.LanguageId = language(that.$store.getters.locale)
			window.onresize = () => {
				return (() => {
					window.fullWidth = document.documentElement.clientWidth;
					that.fullWidth = window.fullWidth;
				})();
			};
			let newbarnch = JSON.parse(JSON.stringify(that.newvehicles)).data;
			newbarnch.forEach(element => {
				if (element.treeLevel == 2) {
					that.vehicles.push({
						value: element.nodeValue,
						label: element.name,
					})
				}
			});
			that.queryDriverInfo(0);
		},
		computed: {
			size() {
				return this.$store.getters.size
			},
			...mapState({
				operator: state => state.user.operator,
				newvehicles: state => state.app.vehicles,
				token: state => state.user.token
			}),
		},
		methods: {
			handleSizeChange(val) {
				this.pageSize = val;
				this.queryDriverInfo(0);
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.queryDriverInfo(0);
			},
			onSubmit() {
				this.queryDriverInfo(0);

			},
			add() {
				this.driverInfo = {};
				this.drivertitle = this.$t('drivermanagement.adddriver');
				this.dialogFormVisible = true;
				this.newstatus = "";
				this.quasiDrivingType = 0;
				this.$set(this.driverInfo, "LicenseValidityPeriod", new Date());
				this.$set(this.driverInfo, "QCValidityperiod", new Date());
				this.$set(this.driverInfo, "Sex", 1);
				this.$nextTick(() => {
					this.$refs["driverInfo"].clearValidate()
				})
			},
			modify(index, row) {
				console.log(row)
				this.drivertitle = this.$t('drivermanagement.modifydriverinfo');
				this.$nextTick(() => {
					this.$refs["driverInfo"].clearValidate()
				})
				this.driverID = row.DriverID;
				this.dialogFormVisible = true;
				this.driverInfo = JSON.parse(JSON.stringify(row)); ////数据赋值 深拷贝代替浅拷贝
				this.newstatus = this.driverInfo.Status;
				const targetType = this.vehicletype.find(item => item.value === this.driverInfo.QuasiDrivingType);
				this.quasiDrivingType = targetType ? targetType.value : ''; // 匹配不到时显示空字符串
			},
			handleDelete(index, row) {
				console.log(row)
				this.driverID = row.DriverID;
				this.$confirm(this.$t('drivermanagement.isdelete'), this.$t('public.tips'), {
					confirmButtonText: this.$t('public.confirm'),
					cancelButtonText: this.$t('public.cancel'),
					type: 'warning'
				}).then(() => {
					// const {
					// 	MaintainID,
					// 	RepairorderNo,
					// 	RepairDate,
					// 	ManhourItem,
					// 	amount,
					// 	WorkHourID
					// } = row[index];
					// this.repairTimelist = JSON.parse(JSON.stringify(row[index])); ////数据赋值 深拷贝代替浅拷贝
					this.saveDriverInfo(this.driverID, 3, this.$t('public.hasDeleted'));
				}).catch(() => {
					// this.$message({
					// 	type: 'info',
					// 	message: '已取消删除'
					// });
				});
			},

			queryDriverInfo(type) {
				var that = this;
				this.loading = true;
				that.$api.queryDriverInfo({
					CompanyID: that.operator.CompanyId,
					CarNo: "",
					DriverName: that.driverName,
					PageNo: that.currentPage,
					PageSize: that.pageSize,
					OperatorID: that.operator.OperatorId,
					IsExport: type,
				}).then((res) => {
					this.loading = false
					if (type == 0) {
						if (res.type == "application/json") {
							const reader = new FileReader();
							reader.readAsText(res, 'utf-8');
							reader.onload = function(e) {
								const readerres = reader.result;
								const parseObj = JSON.parse(readerres);
								that.total = parseObj.count;
								console.log(parseObj);
								if (parseObj.data.length > 0) {
									that.tableData = parseObj.data;
									// that.loading = false;
								} else {
									// that.loading = false;
									that.tableData = [];
								}
							}
						}
					} else {
						// that.loading = false;
						let blob = new Blob([res], {
							type: "application/vnd.ms-excel;charset=utf-8"
						}); // 重点代码
						var driverinfotitle = that.$t('drivermanagement.driverlist') +
							`_${that.timestampToTime(new Date().getTime())}.xlsx`
						let a = document.createElement("a");
						a.href = window.URL.createObjectURL(blob);
						a.setAttribute("download", driverinfotitle); // 表名，自定义
						a.click(); // 执行下载
						window.URL.revokeObjectURL(blob); // 释放ur
					}
				})
			},
			download() {
				this.queryDriverInfo(1);
			},
			determine(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.drivertitle == this.$t('drivermanagement.adddriver')) {
							this.saveDriverInfo(-1, 1, this.$t('public.add_success'));
						} else if (this.drivertitle == this.$t('drivermanagement.modifydriverinfo')) {
							this.saveDriverInfo(this.driverID, 2, this.$t('public.edit_success'));
						}
					} else {
						// console.log('error submit!!');
						return false;
					}
				});
			},
			saveDriverInfo(driverID, type, message) {
				var that = this;
				that.$api.saveDriverInfo({
					DriverID: driverID,
					Driver: that.driverInfo.Driver,
					GroupID: that.driverInfo.GroupID, //分公司ID
					EmployeeCardNo: that.driverInfo.EmployeeCardNo,
					DriverWorkNo: that.driverInfo.DriverWorkNo,
					EmployeeCardID: that.driverInfo.EmployeeCardID,
					Status: that.newstatus,
					LicenseIssuingUnit: that.driverInfo.LicenseIssuingUnit,
					LicenseValidityPeriod: that.driverInfo.LicenseValidityPeriod,
					QualificationCertificate: that.driverInfo.QualificationCertificate,
					QCValidityperiod: that.driverInfo.QCValidityperiod,
					ContactNo: that.driverInfo.ContactNo,
					DriverICNo: that.driverInfo.DriverICNo,
					Sex: that.driverInfo.Sex,
					DriverlicenseNo: that.driverInfo.DriverlicenseNo,
					QuasiDrivingType: that.quasiDrivingType,
					HomeAddress: that.driverInfo.HomeAddress,
					DriverProfile: that.driverInfo.DriverProfile,
					operate: type
				}).then((res) => {
					if (res.code == 200) {
						that.dialogFormVisible = false;
						that.$message({
							type: 'success',
							message: message
						});
						let newPageing = Math.ceil((this.tableData.length - 1) / this
							.pageSize); //Math.ceil向上取整算出新的分页
						let newcurrentPage = this.currentPage > newPageing ? newPageing : this
							.currentPage; //计算当前页应该是哪页
						this.currentPage = newcurrentPage < 1 ? 1 : newcurrentPage; //把当前页的值赋给this.page,重新渲染列表
						that.queryDriverInfo(0);
						that.driverInfo = {};
					} else {
						that.$message({
							type: 'info',
							message: this.$t('public.SaveFail')
						});
					}
				})
			},
			//时间戳转换为日期格式
			timestampToTime(timestamp) {
				var date = new Date(timestamp); //时间数为10位篇*1000，时间数为13位的话不需乘1000
				var Y = date.getFullYear();
				var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
				var D = date.getDate();
				var h = date.getHours();
				var m = date.getMinutes();
				var s = date.getSeconds();
				return Y + M + D + h + m + s;
			}
		}
	}
</script>
<style lang="scss" scoped>
	.adddriverlist {
		::v-deep .el-dialog {
			background: #EEEEEE;
		}
	}

	.registrationInfo {
		margin-top: 10px;
		font-size: 12px;
		text-align: left;
		font-weight: bold !important;
		margin-left: 20px;
		color: black;
		margin-bottom: 10px;
	}

	.adddriverlist {
		::v-deep.el-form-item__label {
			font-size: 12px;
		}
	}

	.adddriverlist {
		::v-deep .el-textarea__inner {
			width: 410px;
			font-size: 12px;
		}
	}
</style>